module.exports = __webpack_public_path__ + "img/bg01@2x.85858477.png";